import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import * as i0 from '@angular/core';
import { inject, Injectable, NgModule } from '@angular/core';
import { CART_NORMALIZER } from '@spartacus/cart/base/root';
import * as i2 from '@spartacus/core';
import { FeatureConfigService, FeatureToggles, provideDefaultConfigFactory } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SavedCartAdapter } from '@spartacus/cart/saved-cart/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OccSavedCartAdapter {
  constructor(http, occEndpoints, converter) {
    this.http = http;
    this.occEndpoints = occEndpoints;
    this.converter = converter;
    this.featureConfigService = inject(FeatureConfigService);
  }
  load(userId, cartId) {
    return this.http.get(this.getSavedCartEndpoint(userId, cartId)).pipe(map(cartResponse => cartResponse.savedCartData), this.converter.pipeable(CART_NORMALIZER));
  }
  loadList(userId) {
    return this.http.get(this.getSavedCartListEndpoint(userId)).pipe(map(cartList => cartList.carts ?? []), this.converter.pipeableMany(CART_NORMALIZER));
  }
  restoreSavedCart(userId, cartId) {
    return this.http.patch(this.getRestoreSavedCartEndpoint(userId, cartId), cartId).pipe(map(cartResponse => cartResponse.savedCartData), this.converter.pipeable(CART_NORMALIZER));
  }
  cloneSavedCart(userId, cartId, saveCartName) {
    let httpParams = new HttpParams();
    if (this.featureConfigService?.isEnabled('occCartNameAndDescriptionInHttpRequestBody')) {
      httpParams = httpParams.set('name', saveCartName);
    }
    const endpoint = this.getCloneSavedCartEndpoint(userId, cartId, saveCartName);
    return this.http.post(endpoint, httpParams).pipe(map(cartResponse => cartResponse.savedCartData), this.converter.pipeable(CART_NORMALIZER));
  }
  getSavedCartEndpoint(userId, cartId) {
    return this.occEndpoints.buildUrl('savedCart', {
      urlParams: {
        userId,
        cartId
      }
    });
  }
  getSavedCartListEndpoint(userId) {
    return this.occEndpoints.buildUrl('savedCarts', {
      urlParams: {
        userId
      }
    });
  }
  getRestoreSavedCartEndpoint(userId, cartId) {
    return this.occEndpoints.buildUrl('restoreSavedCart', {
      urlParams: {
        userId,
        cartId
      }
    });
  }
  getCloneSavedCartEndpoint(userId, cartId, saveCartName) {
    return this.occEndpoints.buildUrl('cloneSavedCart', {
      urlParams: {
        userId,
        cartId,
        saveCartName
      }
    });
  }
  static {
    this.ɵfac = function OccSavedCartAdapter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OccSavedCartAdapter)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OccEndpointsService), i0.ɵɵinject(i2.ConverterService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OccSavedCartAdapter,
      factory: OccSavedCartAdapter.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OccSavedCartAdapter, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2.OccEndpointsService
  }, {
    type: i2.ConverterService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// Imported for side effects (module augmentation)

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultOccSavedCartConfigFactory() {
  const featureToggles = inject(FeatureToggles);
  return {
    backend: {
      occ: {
        endpoints: {
          savedCarts: '/users/${userId}/carts?savedCartsOnly=true&fields=carts(DEFAULT,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL)),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),totalUnitCount,deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue, value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),saveTime,user,name,description)',
          savedCart: '/users/${userId}/carts/${cartId}/savedcart',
          restoreSavedCart: '/users/${userId}/carts/${cartId}/restoresavedcart',
          cloneSavedCart: featureToggles.occCartNameAndDescriptionInHttpRequestBody ? '/users/${userId}/carts/${cartId}/clonesavedcart' : '/users/${userId}/carts/${cartId}/clonesavedcart?name=${saveCartName}'
        }
      }
    }
  };
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SavedCartOccModule {
  static {
    this.ɵfac = function SavedCartOccModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SavedCartOccModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SavedCartOccModule,
      imports: [CommonModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfigFactory(defaultOccSavedCartConfigFactory), {
        provide: SavedCartAdapter,
        useClass: OccSavedCartAdapter
      }],
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SavedCartOccModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      providers: [provideDefaultConfigFactory(defaultOccSavedCartConfigFactory), {
        provide: SavedCartAdapter,
        useClass: OccSavedCartAdapter
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OccSavedCartAdapter, SavedCartOccModule };
